import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'app-receipts',
	templateUrl: './receipts.component.html',
	styleUrls: ['./receipts.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class ReceiptsComponent implements OnInit {

	constructor() {  }

	ngOnInit() {}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/receipts/receipts.component.ts